<script setup>
import ButtonCta from '@/Components/ui/buttons/ButtonCta.vue'
import IconEmail from '../../assets/svg/ico-email.svg'

const locations = [
	{
		id: 1,
		name: 'Port Melbourne, Melbourne',
		address1: '20 Woodruff St,',
		address2: 'Port Melbourne, Victoria 3207',
		email: 'mel@idriverentals.com.au',
		mapHref: 'https://maps.app.goo.gl/DnreVf2vVtuRxsH57',
	},
	{
		id: 2,
		name: 'Alexandria, Sydney',
		address1: '7-9 Ralph St,',
		address2: 'Alexandria, NSW 2015',
		email: 'syd@idriverentals.com.au',
		mapHref: 'https://maps.app.goo.gl/yicjiJUcWmCPTJ1L7',
	},
	{
		id: 3,
		name: 'Clyde, Sydney',
		address1: '14/16 Wentworth Street,',
		address2: 'Clyde, NSW 2142',
		email: 'syd@idriverentals.com.au',
		mapHref: 'https://maps.app.goo.gl/yicjiJUcWmCPTJ1L7',
	},
	{
		id: 4,
		name: 'Eagle Farm, Brisbane',
		address1: '109B Links Ave S,',
		address2: 'Eagle Farm, QLD 4009',
		email: 'bri@idriverentals.com.au',
		mapHref: 'https://maps.app.goo.gl/aRoB76orSmuU2xtW7',
	},
]
</script>

<template>
	<div
		class="my-20 grid grid-cols-1 md:grid-cols-2 lg:px-20 gap-8 px-10 xl:grid-cols-4 xl:px-0 justify-between container xl:w-3/4"
	>
		<div v-for="location in locations" :key="location.id">
			<p class="text-lg font-bold text-idrive-dark mb-1">
				{{ location.name }}
			</p>
			<div class="text-gray-700">
				<p>
					{{ location.address1 }}
				</p>
				<p>
					{{ location.address2 }}
				</p>
			</div>
			<div class="flex flex-col my-4 gap-2">
				<a
					:href="'mailto:' + location.email"
					target="_blank"
					class="w-fit"
				>
					<ButtonCta button-mode="dark" :is-mobile-full-width="false">
						<div class="flex flex-row gap-2 items-center font-bold">
							<IconEmail />
							{{ location.email }}
						</div>
					</ButtonCta>
				</a>
				<a :href="location.mapHref" target="_blank" class="w-fit">
					<ButtonCta button-mode="gray" :is-mobile-full-width="false">
						<span class="text-sm font-thin">
							View on googlemaps
						</span>
					</ButtonCta>
				</a>
			</div>
		</div>
	</div>
</template>
